import config from 'config';

/**
 * This is devices for 13/1034 skus.
 * @param sku : sku object reference to sku
 *
 * note: prod/stage is not in parity with skus created. So, we pass in the config (sku).
 *       so remember, we'll either get a prod key for value, or the staging value.
 */
const DEVICE_INFO = (sku) => {
  const qid = sku[4172];

  return {
    51: {
      macDesktop: { label: 'Desktop', preQuestion: { qid: 1265, answers: { id: 3722 } } },
      macLaptop: { label: 'Laptop', preQuestion: { qid: 1265, answers: { id: 3723 } } },
      windowsDesktop: { label: 'Desktop', preQuestion: { qid: 1265, answers: { id: 3720 } } },
      windowsLaptop: { label: 'Laptop', preQuestion: { qid: 1265, answers: { id: 3721 } } },
      other: { label: 'Other', preQuestion: { qid: 1265, answers: { id: 3724 } } },
    },
    4172: {
      macDesktop: { label: 'Desktop', preQuestion: { qid, answers: { id: sku[10422] } } },
      macLaptop: { label: 'Laptop', preQuestion: { qid, answers: { id: sku[10423] } } },
      windowsDesktop: { label: 'Desktop', preQuestion: { qid, answers: { id: sku[10420] } } },
      windowsLaptop: { label: 'Laptop', preQuestion: { qid, answers: { id: sku[10421] } } },
      other: { label: 'Other', preQuestion: { qid, answers: { id: sku[10424] } } },
    },
  };
};

/**
 * Prouct brands
 */
export const BRANDS = {
  apple: { id: 9, label: 'Apple' },
  google: { id: 10, label: 'Google' },
  lenovo: { id: 53, label: 'Lenovo' },
  toshiba: { id: 47, label: 'Toshiba' },
  asus: { id: 56, label: 'Asus' },
  alienware: { id: 58, label: 'Alienware' },
  razer: { id: 60, label: 'Razer' },
  dell: { id: 51, label: 'Dell' },
  hp: { id: 52, label: 'HP' },
  microsoft: { id: 54, label: 'Microsoft' },
  acer: { id: 55, label: 'Acer' },
  sony: { id: 57, label: 'Sony' },
  huawei: { id: 59, label: 'Huawei' },
};

/**
 *  We need to get at our "sku specific device types
 *
 * @param id - question id
 * @parma sku - sku object reference
 */
export const BRAND_TYPES = (id, sku = {}) => {
  const { macLaptop, macDesktop, windowsLaptop, windowsDesktop, other } = DEVICE_INFO(sku)[id];

  return {
    brandOther: { id: 'brandOther', ...other },
    laptopApple: { id: 166, ...macLaptop },
    desktopApple: { id: 167, ...macDesktop },
    laptopGoogle: { id: 168, ...windowsLaptop },
    desktopGoogle: { id: 169, ...windowsDesktop },
    laptopDell: { id: 170, ...windowsLaptop },
    desktopDell: { id: 171, ...windowsDesktop },
    laptopHP: { id: 172, ...windowsLaptop },
    desktopHP: { id: 173, ...windowsDesktop },
    laptopLenovo: { id: 174, ...windowsLaptop },
    desktopLenovo: { id: 175, ...windowsDesktop },
    laptopMicrosoft: { id: 176, ...windowsLaptop },
    desktopMicrosoft: { id: 177, ...windowsDesktop },
    laptopToshiba: { id: 178, ...windowsLaptop },
    desktopToshiba: { id: 179, ...windowsDesktop },
    laptopAcer: { id: 180, ...windowsLaptop },
    desktopAcer: { id: 181, ...windowsDesktop },
    laptopAsus: { id: 182, ...windowsLaptop },
    desktopAsus: { id: 183, ...windowsDesktop },
    laptopSony: { id: 184, ...windowsLaptop },
    desktopSony: { id: 185, ...windowsDesktop },
    laptopAlienware: { id: 186, ...windowsLaptop },
    desktopAlienware: { id: 187, ...windowsDesktop },
    laptopHuawei: { id: 188, ...windowsLaptop },
    laptopRazer: { id: 189, ...windowsLaptop },
    desktopRazer: { id: 190, ...windowsDesktop },
    laptop: { id: 'laptop', ...windowsLaptop },
    desktop: { id: 'desktop', ...windowsDesktop },
  };
};

/**
 * Production id's will always be dominant. We will use those as a base.
 * This means that primary keys will be production dominant, the value is the override.
 *
 * The ONLY reason this is here is because of the inevitable mismatches when a person
 * updates a sku in prod but does not do it in staging. If we update in staging at a later time via db inserts,
 * we run the risk of subsequent admin updates in staging unable to complete because we've created
 * Id's outside the flow.
 *
 * [production_value]: [staging_value]
 *
 * Note: we added proxies in that IF a value doesn't exist, we fall back to the production key.
 *       We usually can mimic development (update db), so that is covered. And of course, production proper.
 *
 * NOTE: This was never the intent to do this. Its goofy. Hopefully when we get an update from prod, we'll remove this.
 * */
const answerIdsForSku879 = {
  879: {
    // [prodId] : [stagingId]
    // questions
    5749: 4490,
    5750: 4491,
    5751: 4492,
    5752: 4493,
    5753: 4494,
    5754: 4495,
    5755: 4496,
    5756: 4497,
    // answers
    // answer ids for question id 5749
    14046: 11167,
    14047: 11168,
    14048: 11169,
    // answer ids for question id 5750
    14049: 11170,
    14050: 11171,
    14051: 11172,
    14052: 11173,
    // answer ids for question id 5751
    14053: 11174,
    14054: 11175,
    // answer ids for question id 5752
    14055: 11176,
    14056: 11177,
    // answer ids for question id 5753
    14059: 11178,
    14060: 11179,
    14172: 11180,
    14173: 11181,
    // answer ids for question id 5754
    14064: 11185,
    14065: 11186,
    14066: 11187,
    14067: 11188,
    14068: 11189,
    // answer ids for question id 5755
    14069: 11190,
    14070: 11191,
    // answer ids for question id 5756
    14071: 11192,
  },
};
const skuIds = {
  staging: {
    ...answerIdsForSku879,
    1034: {
      // questions
      4169: 4121,
      4171: 4122,
      4170: 4123,
      4172: 4124,
      // answers
      // 4169
      10404: 10303,
      10405: 10304,
      10406: 10305,
      10407: 10306,
      // 4170s
      10409: 10309,
      10410: 10310,
      10411: 10311,
      10412: 10312,
      10413: 10313,
      10414: 10314,
      10415: 10315,
      10416: 10316,
      10417: 10317,
      // 4171
      10418: 10307,
      10419: 10308,
      // 4172
      10420: 10318,
      10421: 10319,
      10422: 10320,
      10423: 10321,
      10424: 10322,
    },
  },
  production: { 1034: {}, 879: {} },
  development: {
    1034: {},
    879: {},
    // ...answerIdsForSku879, // Uncomment this line  if local DB mirrors staging
  },
}[config.env];

const handler = {
  get(target, key) {
    if (typeof target[key] === 'object' && target[key] !== null) {
      return new Proxy(target[key], handler);
    }

    return target[key] || +key;
  },
};

export const SKU_CONFIG_IDS = new Proxy(skuIds, handler);
